import React, {useEffect, useMemo, useRef} from "react";
import { withStyles } from "@material-ui/styles";
import { connect } from "react-redux";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import TextField from "../../../../../../ui/TextField";
import DataSelect from "../../../../../../ui/DataSelect";
import Progress from "../../../../../../ui/Progress";

import {getEduForms as getDictEduForms,
        getTargetGroups as getDictTargetGroups} from "../../../../../../ManageOOP/Resources/OpMod/MyOPMod/store/actions";
import {
  getDictOrganizations,
  getDictWsCategories,
  getSkillsByCategory,
  getDictTrialForms,
} from "../../../../../../Dict/store/actions";

import { loadList as getDictRegions } from "../../../../../../Dict/Region/View/fetch";
import { getSpecialities } from "../../../../../../Dict/Skills/Speciality/store/actions";
import {
  ColoredStateIcon,
  StateTextColor
} from "../../../../../../ManageOOP/Resources/OpMod/MyOPMod/components/StateStyles";
import CardInfoField from "../../../../../../ui/CardInfoField";
import {format, parseISO} from "date-fns";
import ru from "date-fns/locale/ru";


const styles = () => ({
  root: {
    maxWidth: 774,
    minWidth: 400,
    marginLeft: 8,
    marginRight: 8,
    "& .MuiFormLabel-root": {
      whiteSpace: "nowrap"
    },
    "& .MuiInputBase-input.Mui-disabled": {
      color: "#000"
    },
    "& .MuiGrid-spacing-xs-4 > .MuiGrid-item": {
      paddingTop: 4,
      paddingBottom: 5
    }
  },
  container: {
    width: "100%",
    marginTop: "16px"
  },
  heading: {
    fontSize: 14,
    lineHeight: "18px",
    display: "flex",
    alignItems: "center",
    color: "#000000",
    margin: "8px 0"
  },
  mainGrid:{
    marginTop: 8
  },
  block: {
    margin: "35px 0 15px 0"
  },
  blockrow: {
    marginTop: 24
  },
  checkbox: {
    "& > .MuiCheckbox-colorPrimary.Mui-checked": {
      color: "rgba(0, 127, 189, 0.7);"
    }
  },
  label: {
    fontSize: 12
  },
  typofield: {
    width: 120,
    minWidth: 120,
    paddingRight: 16
  },
  typovalue: {
    fontSize: 12,
  },
  svgIcon:{
    display: "inline-block",
    marginBottom: "-8px",
    marginRight: "8px"
  }
});

const defaultData = {
  duration: null,
  code: "",
  name: "",
  qualification: "",
  targetGroup: null,
  speciality: null,
  skill: null,
  regionId: null,
  organization: null,
  year: null,
  educationForm: null,
  trialForm: null,
  description: ""
};

const formatDate = date =>
  date ? format(parseISO(date), "dd.MM.yyyy", { locale: ru }) : null;

const ProgramMainInfoEdit = ({
                               classes,
                               programInfo,
                               programData,
                               onFormChange,
                               disabled,
                               isEdited,
                               programId,
                               getDictOrganizations, organizations,
                               getDictWsCategories, categories,
                               getSkillsByCategory, skills,
                               getDictRegions, regions,
                               getSpecialities, specialities,
                               getDictEduForms, eduFormList,
                               getDictTargetGroups, targetGroupList,
                               getDictTrialForms, trialFormList
                             }) => {
  const [data, setData] = React.useState(programData || defaultData);
  const { duration, code, name, qualification, targetGroup, speciality,
    skill, organization, year, educationForm, trialForm, description } = data;

  const [category, setCategory] = React.useState(programInfo.skill ? programInfo.skill.categoryId : null);
  const [region, setRegion] = React.useState(programInfo.organization ? programInfo.organization.regionId : null);
  const [metaTitle, setMetaTitle] = React.useState("");
  const [metaDescr, setMetaDescr] = React.useState("");

  const onChange = (field, value) => {
    const newState = {
      ...data,
      [field]: value
    };

    setData(newState);
    onFormChange && onFormChange(newState);
  };

  React.useEffect(() => {
    getDictRegions();
    getDictWsCategories();
    getSpecialities();
    getDictTargetGroups();
    getDictTrialForms();
    getDictEduForms();
  }, []);

  React.useEffect(() => {
    if (region && region > -1)
      getDictOrganizations(region);
  }, [region]);

  React.useEffect(() => {
    if (category && category > -1)
      getSkillsByCategory(category);
  }, [category]);



  return(
    (programData && programInfo) ? (
      <div className={classes.root}>
        <Typography className={classes.heading}>Основные сведения</Typography>
        <Grid container spacing={1} className={classes.mainGrid}>
          <Grid item xs={6} lg={2}>
            <TextField
              required
              value={code}
              onChange={e => onChange("code", e.target.value)}
              label="Код"
              disabled={disabled}
            />
          </Grid>
          <Grid item xs={6} lg={10}>
            <TextField
              required
              value={name}
              onChange={e => onChange("name", e.target.value)}
              label="Наименование"
              disabled={disabled}
            />
          </Grid>
          <Grid item xs={6}>
            {categories &&
            <DataSelect
              value={category}
              onChange={value => setCategory(value._key)}
              dataSource={categories}
              label="Направление"
              disabled={disabled}
              keyField="_key"
            />}
          </Grid>
          <Grid item xs={6}>
            {skills &&
            <DataSelect
              value={skill}
              onChange={value => onChange("skill", value._key)}
              dataSource={skills}
              label="Компетенция"
              disabled={disabled}
              keyField="_key"
            />}
          </Grid>
          <Grid item xs={6}>
            {specialities &&
            <DataSelect
              value={speciality}
              onChange={value => onChange("speciality", value.id)}
              getOptionLabel={option => option && `${option.code} | ${option.name}`}
              dataSource={specialities}
              label="Профессия/Специальность"
              disabled={disabled}
            />}
          </Grid>
          <Grid item xs={6}>
            <TextField
              value={qualification}
              onChange={e => onChange("qualification", e.target.value)}
              label="Присваеваемый квалификационный разряд"
              disabled={disabled}
            />
          </Grid>

          <Grid item xs={6}>
            {regions &&
            <DataSelect
              value={region}
              onChange={value => setRegion(value.id)}
              dataSource={regions}
              disabled={disabled}
              label="Регион"
              //keyField="id"
            />}
          </Grid>
          <Grid item xs={6}>
            {organizations &&
            <DataSelect
              value={organization}
              onChange={value => onChange("organization", value._key)}
              label="Реализуется партнёром"
              dataSource={organizations}
              disabled={disabled}
              required
              keyField="_key"
            />}
          </Grid>
          <Grid item xs={6}>
            {targetGroupList &&
            <DataSelect
              value={targetGroup}
              onChange={value => onChange("targetGroup", value.id)}
              label="Для кого"
              dataSource={targetGroupList}
              disabled={disabled}
              keyField="id"
            />}
          </Grid>
          <Grid item xs={6}>
            {eduFormList &&
            <DataSelect
              value={educationForm}
              onChange={value => onChange("educationForm", value.id)}
              label="Форма обучения"
              dataSource={eduFormList}
              disabled={disabled}
              //keyField="_key"
            />}
          </Grid>
          <Grid item xs={6}>
            <Grid container spacing={2}>
              <Grid item xs={4}>
                <TextField
                  value={year}
                  label="Год"
                  onChange={e => onChange("year", e.target.value)}
                  disabled={disabled}
                />
              </Grid>
              <Grid item xs={4}>
                <TextField
                  value={duration}
                  label="Объём"
                  onChange={e => onChange("duration", e.target.value)}
                  disabled={disabled}
                />
              </Grid>
              <Grid item xs={4}>
                {trialFormList &&
                <DataSelect
                  value={trialForm}
                  onChange={value => onChange("trialForm", value._key)}
                  label="Форма аттест."
                  dataSource={trialFormList}
                  disabled={disabled}
                  keyField="_key"
                />}
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <TextField
              value={description}
              onChange={e => onChange("description", e.target.value)}
              label="Описание"
              disabled={disabled}
            />
          </Grid>
        </Grid>

        <div className={classes.block}>
          <div className={classes.blockrow}>
            <Typography
              className={classes.typofield}
              variant="caption"
              color="textSecondary">
              Статус программы:
            </Typography>
            <Typography className={classes.typovalue} variant="caption">
              {ColoredStateIcon(programInfo.statusId)}
              <span style={{
                color: StateTextColor(programInfo.statusId)
              }}>{programInfo.statusName}</span>
            </Typography>
          </div>
          <div className={classes.blockrow}>
            <CardInfoField field="Дата создания:" value={formatDate(programInfo.creationDate)} wide="true"/>
          </div>
          {programInfo.expertise &&
          <div className={classes.blockrow}>
            <CardInfoField field="Дата экспертизы:" value={formatDate(programInfo.expertise.statusDate)} wide="true"/>
          </div>
          }
          <div className={classes.blockrow}>
            <CardInfoField field="Дата публикации:" value={formatDate(programInfo.publicationDate)} wide="true"/>
          </div>
        </div>
      </div>) : (
      <div className={classes.progress}>
        <Progress />
      </div>
    )
  );
}

const mapStateToProps = state => ({
  //programFullInfo: state.programs.programFullInfo,
  organizations: state.dictAll.organizationList,
  categories: state.dictAll.wsCategoryList,
  skills: state.dictAll.skillList,
  regions: state.dictRegionView.list,
  specialities: state.specialities.specialities,
  targetGroupList: state.programs.targetGroups,
  trialFormList: state.dictAll.trialFormList,
  eduFormList: state.programs.eduForms
});

const mapDispatchToProps = dispatch => ({
  getDictOrganizations: (regionId) => dispatch(getDictOrganizations(regionId)),
  getDictWsCategories: () => dispatch(getDictWsCategories()),
  getSkillsByCategory: (categoryId) => dispatch(getSkillsByCategory(categoryId)),
  getDictRegions: () => dispatch(getDictRegions()),
  getSpecialities: () => dispatch(getSpecialities()),
  getDictTargetGroups: () => dispatch(getDictTargetGroups()),
  getDictTrialForms: () => dispatch(getDictTrialForms()),
  getDictEduForms: () => dispatch(getDictEduForms())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(ProgramMainInfoEdit));
